import { render, staticRenderFns } from "./workBench.vue?vue&type=template&id=e3fd39b6&"
import script from "./workBench.vue?vue&type=script&lang=js&"
export * from "./workBench.vue?vue&type=script&lang=js&"
import style0 from "./workBench.vue?vue&type=style&index=0&id=e3fd39b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports